import PropTypes from 'prop-types';
import React from 'react';

import { listsHeroSectionShape, listsHeroSectionValidationShape } from 'app/shapes/admin/browse/home';
import { LISTS_HERO_NUM_MAX_LIST_URLS, LISTS_HERO_NUM_MIN_LIST_URLS } from 'app/constants/admin/browse/home';
import EditorListUrls from './shared/EditorListUrls';

import './SectionEditorListsHero.scss';

const SectionEditorListsHero = ({ onChange, section: listsHeroSection, validation }) => {
  const { listUrls, sectionId } = listsHeroSection;

  const handleListUrlsChange = newListUrls => {
    onChange({
      ...listsHeroSection,
      listUrls: newListUrls
    });
  };

  const editorListUrlsKey = `${sectionId}_EditorListUrls`;

  return (
    <div className="cp-admin-browse-home-editor-lists-hero">
      <p className="rules">
        {LISTS_HERO_NUM_MIN_LIST_URLS}&ndash;{LISTS_HERO_NUM_MAX_LIST_URLS} lists can be added.
      </p>

      <EditorListUrls
        key={editorListUrlsKey}
        listUrls={listUrls}
        listUrlErrors={validation.errorByAttribute.listUrls}
        numRowsMax={LISTS_HERO_NUM_MAX_LIST_URLS}
        numRowsMin={LISTS_HERO_NUM_MIN_LIST_URLS}
        onChange={handleListUrlsChange}
      />
    </div>
  );
};

SectionEditorListsHero.defaultProps = {
  validation: {
    isValid: true,
    errorByAttribute: {
      listUrls: []
    }
  }
};

SectionEditorListsHero.propTypes = {
  onChange: PropTypes.func.isRequired,
  section: listsHeroSectionShape.isRequired,
  validation: listsHeroSectionValidationShape
};

export default SectionEditorListsHero;
